import { GroupAnimationWithThen, } from "motion-dom";
import { animateElements } from "./animate-elements";
export const createScopedWaapiAnimate = (scope) => {
    function scopedAnimate(elementOrSelector, keyframes, options) {
        return new GroupAnimationWithThen(animateElements(elementOrSelector, keyframes, options, scope));
    }
    return scopedAnimate;
};
export const animateMini = /*@__PURE__*/ createScopedWaapiAnimate();
//# sourceMappingURL=animate-style.js.map